const pageNameKey = "otaBackupProcessAcceptAndCreate";

export const otaBackupProcessAcceptAndCreateEn = {
  [pageNameKey]: {
    title: "Backup Process Approved by Operator.",
    descriptionTemplate:
      "{approver} accepted the backup process. Now, review and create the backup of the machine.",
    acceptAndCreateBackupButtonText: "Accept and Create Backup",
  },
};

export const otaBackupProcessAcceptAndCreatePtBr = {
  [pageNameKey]: {
    title: "Processo de backup aprovado pelo Operador.",
    descriptionTemplate:
      "{approver} aceitou o processo de backup. Agora, revise e crie o backup da maquina.",
    acceptAndCreateBackupButtonText: "Aceitar e criar backup",
  },
};

export const otaBackupProcessAcceptAndCreateDe = {
  [pageNameKey]: {
    title: "Backup-Prozess vom Operator genehmigt.",
    descriptionTemplate:
      "{approver} hat den Backup-Prozess akzeptiert. Pruefen Sie nun den Prozess und erstellen Sie das Backup der Maschine.",
    acceptAndCreateBackupButtonText: "Akzeptieren und Backup erstellen",
  },
};

export const otaBackupProcessAcceptAndCreateZhHans = {
  [pageNameKey]: {
    title: "备份流程已由操作员批准。",
    descriptionTemplate:
      "{approver} 已接受备份流程。现在，请审核并创建设备备份。",
    acceptAndCreateBackupButtonText: "接受并创建备份",
  },
};

export const otaBackupProcessAcceptAndCreateIt = {
  [pageNameKey]: {
    title: "Processo di backup approvato dall'Operatore.",
    descriptionTemplate:
      "{approver} ha accettato il processo di backup. Ora, rivedi e crea il backup della macchina.",
    acceptAndCreateBackupButtonText: "Accetta e crea backup",
  },
};

export const otaBackupProcessAcceptAndCreateEs = {
  [pageNameKey]: {
    title: "Proceso de respaldo aprobado por el Operador.",
    descriptionTemplate:
      "{approver} acepto el proceso de respaldo. Ahora, revise y cree el respaldo de la maquina.",
    acceptAndCreateBackupButtonText: "Aceptar y crear respaldo",
  },
};

export const otaBackupProcessAcceptAndCreateNl = {
  [pageNameKey]: {
    title: "Back-upproces goedgekeurd door de operator.",
    descriptionTemplate:
      "{approver} heeft het back-upproces geaccepteerd. Controleer het proces en maak nu de back-up van de machine.",
    acceptAndCreateBackupButtonText: "Accepteren en back-up maken",
  },
};

export const otaBackupProcessAcceptAndCreateTr = {
  [pageNameKey]: {
    title: "Yedekleme İşlemi Operatör Tarafından Onaylandı.",
    descriptionTemplate:
      "{approver} yedekleme işlemini kabul etti. Şimdi makinenin yedeğini gözden geçirin ve oluşturun.",
    acceptAndCreateBackupButtonText: "Kabul Et ve Yedekleme Oluştur",
  },
};
